import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import MarkAllAsReadBase from 'components/notifications/Dashboard/components/MarkAllAsRead';
import colors from 'config/theme/colors';
import { PATH } from 'constants/RoutesConstants';

import { Row, Col } from 'ui/base';

const Wrapper = styled(Row)`
  padding: 0 32px;
  color: ${colors['@text-color-secondary']} !important;
  
  > div:first-child {
  flex: 1 0 0;
  }

  h3 {
    margin: 0 !important;
    font-size: 22px;
    font-weight: 500 !important;
  }
`;

const Icon = styled.i`
  cursor: pointer;
  color: ${colors['@font-grey-light']};
  vertical-align: middle;
  font-size: 20px;
`;

const MarkAllAsRead = styled(MarkAllAsReadBase)`
  padding: 0;
  margin-bottom: 0px;
`;

const Header = ({ disabled, onClick }) => (
  <Wrapper type="flex" justify="space-between" align="middle">
    <Col>
      <FormattedMessage id="notifications.header" defaultMessage="Notifications" tagName="h3" />
    </Col>
    <Col>
      <MarkAllAsRead disabled={disabled} />
    </Col>
    <Col>
      <Link to={PATH.USER_NOTIFICATIONS_SETTINGS.path} onClick={onClick} data-cy="notifications-dropdown-settings">
        <Icon className="fb-icon--settings" />
      </Link>
    </Col>
  </Wrapper>
);

export default Header;
